import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';
import QuizBlockChoose from './Components/BlockQuiz'
//import MemoryClass from "./memoryClass";
import axios from 'axios';

// const ASSETS_BASE = /localhost/.test(window.location.href) ? "" : "/global17/bundles/games/dist";
let ASSETS_BASE = '';
if(true){
    ASSETS_BASE = '/global17/bundles/games/dist'; //head-game-4
}else{
    ASSETS_BASE = '';
}


//CLASSE MEMORY GAME
class QuizGameLast extends React.Component{

    constructor(props) {
        super(props)
        this.state = {
            quiz:[
                {
                    title:'A quale età i denti dei conigli smettono di crescere?',
                    choose1:'Mai',
                    choose2:'A 5 anni',
                    choose3:'A 6 mesi',
                } ,   {
                    title:'Perché il coniglio batte le zampe posteriori per terra?',
                    choose1:'Per richiamare l’attenzione',
                    choose2:'Perché si sente in pericolo',
                    choose3:'Per esprimere gioia',
                } , {
                    title:'Quante dita ha la zampa posteriore del coniglio?',
                    choose1:'4',
                    choose2:'3',
                    choose3:'5',
                } , {
                    title:'Quale, tra questi alimenti, non è adatto al coniglio?',
                    choose1:'Lattuga',
                    choose2:'Pane',
                    choose3:'Cavolo',
                } ,  {
                    title:'I conigli selvatici vivono...',
                    choose1:'Isolati',
                    choose2:'In gruppi',
                    choose3:'In coppia',
                } , {
                    title:'Come si chiama il celebre coniglio nato dalla fantasia di Beatrix Potter?',
                    choose1:'Peter Rabbit',
                    choose2:'Roger Rabbit',
                    choose3:'Bugs Bunny ',
                },  {
                    title:'Quali di questi denti non hanno i conigli?',
                    choose1:'Canini',
                    choose2:'Molari',
                    choose3:'Premolari',
                }  ,  {
                    title:'Come vedono i conigli?',
                    choose1:'Hanno una vista panoramica, quasi a 360°',
                    choose2:'Possono vedere solo davanti a loro',
                    choose3:'Vedono solo da molto vicino',
                } , {
                    title:'Come marcano il territorio i conigli?',
                    choose1:'Sfregando la testa',
                    choose2:'Sfregando la coda',
                    choose3:'Sfregando il mento',
                }, {
                    title:'Come esprime felicità il coniglio?',
                    choose1:'Con salti e corse anche improvvisi',
                    choose2:'Muovendo il naso',
                    choose3:'Emettendo un verso',
                }
            ],
            logged:true,
            choose:[],
            match:["1","2","1","2","2","1", "1","1","3","1"],
            winGame:false,
            step:0,
            countMatch:0,
            remainingTime:   90,
            started: false,
            ended: false,
            img:   ""
        }
        //bind methods
        this.startTimer  = this.startTimer.bind(this);
        this.stepChoose  = this.stepChoose.bind(this);
        this.nextStep  = this.nextStep.bind(this);
        this.saveResult  = this.saveResult.bind(this);

    }
    componentDidMount() {
        this.setState(
            { logged: document.getElementById("gamefourquiz").getAttribute("logged") === "true" ? true : false }
        )
        //this.startTimer()
    }
    end(win = false) {
        if(win)
            console.log("Winner!");
        else
            console.log("Loser!");
    }



    startTimer() {
        this.setState({started: true}, () => {
            setInterval(() => {
                if(this.state.started && !this.state.ended)
                    if(this.state.remainingTime === 1)
                        this.setState({
                            remainingTime: this.state.remainingTime - 1,
                            started: true,
                            ended:   true
                        }, () => {
                            this.end();
                        });
                    else
                        this.setState({
                            remainingTime: this.state.remainingTime - 1
                        });
            }, 1000);
        });
    }

    nextStep( e ){
        //contatore risposte corrette
        if( e  == this.state.match[this.state.step]  ) {
            this.setState({
                countMatch: this.state.countMatch += 1
            })
        }
        console.log([ this.state.step, this.state.quiz.length, 'result' , e,   this.state.match[this.state.step],  this.state.countMatch  ])
        this.setState({
            choose:  [...this.state.choose,e],
            step: this.state.step +=1
        }, ()=> {
            this.setState({
                ended:(this.state.choose.length !=  this.state.quiz.length    ) ? false : true
            })
        })

    }
    saveResult() {

        if(this.state.ended){

            let self = this;
            axios({
                method: 'get',
                url: '/giochi/add-result-by-userid?totalMatch='+self.state.countMatch,
            })
                .then(function (response) {
                    console.log(response);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }


    stepChoose(){
        //LOGIN TRUE
        let totalMatch =  this.state.countMatch;
        /*console.log( "stepChoose " + this.state.countMatch );*/
        if(this.state.logged){

            let final = (  this.state.step > this.state.quiz.length -1  ) ? false : true;

            if( this.state.remainingTime == 0 ){
                this.saveResult();
                return (
                    <div className={'popupstyle'}>
                        <div>
                            <p><b style={{ fontWeight:'bold' }}>QUANTO NE SAI SUI CONIGLI?</b></p>
                            <p>Hai risposto correttamente a { this.state.countMatch  } domande su { this.state.quiz.length } !</p>
                            <p>Grazie per aver partecipato e continua a seguire la community!</p>
                            <a onClick={()=>{ location.reload() }} className={'btn btnpoup'}>Gioca di nuovo</a>
                        </div>
                    </div>
                )
            }
            if(final){

                return(
                    <QuizBlockChoose
                        customCallback={  this.nextStep }
                        title  ={ this.state.quiz[this.state.step].title }
                        choose1={ this.state.quiz[this.state.step].choose1 }
                        choose2={ this.state.quiz[this.state.step].choose2 }
                        choose3={ this.state.quiz[this.state.step].choose3 }
                    />
                )
            }  else {
                this.saveResult();
                return (
                    <div className={'popupstyle'}>
                        <div>
                            <p><b style={{ fontWeight:'bold' }}>QUANTO NE SAI SUI CONIGLI?</b></p>
                            <p>Hai risposto correttamente a { this.state.countMatch  } domande su { this.state.quiz.length } !</p>
                            <p>Grazie per aver partecipato e continua a seguire la community!</p>
                            <a onClick={()=>{ location.reload() }} className={'btn btnpoup'}>Gioca di nuovo</a>
                        </div>
                    </div>
                )
            }
        }
        /* else{
             return(<div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                 <button style={{margin: "0 auto", padding: "1em 3em", background: "#EA2328", color: "#fff", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
                     Accedi / Registrati per giocare!
                 </button>
             </div> )
         }*/
    }

    render(){

        const { remainingTime, started , logged } = this.state;

        return (
            <div>
                <div>
                    {logged && !started &&(
                        <div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                            <button onClick={()=>{
                                this.startTimer();
                            }} style={{ maxWidth:"400px", margin: "0 auto", padding: "1em 3em", background: "#ffffff", color: "#EA2328", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"}  >
                                Clicca per giocare!
                            </button>
                        </div>
                    )}
                    {logged && started && (
                        <div className={"container-fluid"}>

                            <div className={'row'}>
                                <div className={'col-md-2 col-xs-12'}>  </div>
                                <div className={'col-md-8 col-xs-12 bodyGame'}>
                                    <img className={"time-icon"} src={ ASSETS_BASE + "/images/time.png"} />
                                    <span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
 								</span>
                                    <div>
                                        {   this.stepChoose()  }
                                    </div>
                                </div>
                                <div className={'col-md-2 col-xs-12'}> </div>
                            </div>
                        </div>
                    )}
                    { !logged &&(
                        <div className={""} style={{textAlign: "center", padding: "2em 0"}}>
                            <button style={{ maxWidth:"400px", margin: "0 auto", padding: "1em 3em", background: "#ffffff", color: "#EA2328", width: "100%", fontSize: "18px", whiteSpace: "normal"}} className={"btn"} onClick={() => window.location.href = `/authentication?ref=${window.location.pathname}`} >
                                Accedi / Registrati per giocare!
                            </button>
                        </div>
                    ) }
                </div>


                <div>




                    {/*<div className={"header"}>
                    <div className={"container"}>
                        <div className={"logo"}>Logo purina</div>
                        <div className={"flex j-center a-center"}>
                            <div className={"time flex j-center a-center"}>
                                <img className={"time-icon"} src={ASSETS_BASE + "/images/time.png"} />
                                <span className={"time-remaining"}>
									TEMPO RESIDUO <strong><Timer started={started} remainingTime={remainingTime} /></strong>
 								</span>
                            </div>
                        </div>
                        <div className={"time flex j-center a-center"}>
                            <h1> GAME MEMORY 111</h1>
                            <div className={"win_block"}>
                                Complimenti hai vinto!
                            </div>
                        </div>
                    </div>
                </div>*/}


                </div>
            </div>
        )
    }
}

const Timer = ({ remainingTime }) => {
    const mins = Math.floor(remainingTime/60) < 10 ? `0${Math.floor(remainingTime/60)}` : Math.floor(remainingTime/60);
    const secs = (remainingTime%60) < 10 ? `0${(remainingTime%60)}` : (remainingTime%60);
    return (
        <Fragment>
            {mins}:{secs}
        </Fragment>
    );
}



document.addEventListener("DOMContentLoaded", () => {
    const mountPoint = document.getElementById("gamefourquiz");
    if(mountPoint)
        ReactDOM.render(<QuizGameLast />, mountPoint);
});
